import React from 'react';
import styled from 'styled-components';
import { withCssSelector } from '../../shared/withCssSelector';
import { BoxedFieldProps, boxedFieldStates } from '../../shared/boxedField';

const StyledTextArea = styled.textarea<BoxedFieldProps>`
	font-family: ${props => props.theme.font};
	accent-color: ${props => props.theme.form.input.accentColor};
	// Native date pickers, number spinners, autofill and scrollbars follow this.
	color-scheme: dark;

	display: block;
	width: 100%;
	padding: 8px 10px;
	font-size: 14px;
	line-height: 1.42857143;
	color: ${props => props.theme.form.input.color};
	background-color: ${props => props.theme.form.input.background};
	background-image: none;

	::placeholder {
		color: ${props => props.theme.form.input.placeholderColor};
	}

	// Stroke and states — shared with Input, SearchInput and the dropdown trigger.
	${boxedFieldStates}
`;

export type TextAreaProps = {
	hasError?: boolean | undefined
} & React.ComponentPropsWithoutRef<'textarea'>

export const TextArea = withCssSelector(React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
	function TextArea(
		{
			hasError,
			disabled,
			tabIndex,
			readOnly,
			...props
		},
		ref
	) {
		return <StyledTextArea
			ref={ref}
			$hasError={hasError}
			$disabled={disabled}
			tabIndex={disabled ? -1 : tabIndex}
			readOnly={disabled ? true : readOnly}
			{...props}
		/>;
	}
), StyledTextArea.toString());
